import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import ModalInfo from '../../../../../../molecules/ModalInfo';
import { ROUTES } from '../../../Routes/ClientRoutes';
import useGetNewProjectData from '../../../../hooks/useGetNewProjectData';
import { RootState } from '../../../../../../redux/root';

type Props = {
  showModal: boolean;
  setShowModal: Function;
};

const ProjectCreatedModal: FC<Props> = ({ showModal, setShowModal }) => {
  const history = useHistory();
  const vocabulary = useSelector((s: RootState) => s.general.vocabulary);
  const { loadProjects } = useGetNewProjectData();

  const onClose = () => {
    setShowModal(false);
    loadProjects(vocabulary, true);
    history.push(ROUTES.PROJECTS);
  };

  if (!showModal) return null;

  return <ModalInfo onClose={onClose} />;
};

export default ProjectCreatedModal;
